import type { ControlSession } from './sessionMachine'

/**
 * Controllee-side security gate. Inject an incoming control packet ONLY when:
 * we are an ACTIVE controllee session, the packet's sessionId matches ours, and
 * the LiveKit-verified sender identity equals the approved controller. No active
 * session ⇒ a spoofed/replayed packet is inert.
 */
export function shouldInject(session: ControlSession, senderIdentity: string, sessionId: string): boolean {
  return (
    session.state === 'active' &&
    session.role === 'controllee' &&
    session.sessionId === sessionId &&
    session.controllerIdentity === senderIdentity
  )
}
